import ApiService from "./apiservice";
import moment from "moment";
import SecureLS from "secure-ls";
var ls = new SecureLS({ encodingType: 'aes' });
import { checkCreateButtonPermission, checkDeleteButtonPermission, checkUpdateButtonPermission, checkExportButtonPermission } from './utils'
export default {
	components: {},
	data() {
		return {
			screenId: "",
		}
	},
	methods: {
		format_date(value) {
			if (value) {
				return moment(String(value)).format('YYYY/MM/DD HH:mm')
			}
		},
		async callApi(method, url, dataObject) {
			if (method == "get") {
				return await ApiService.get(url, dataObject);
			} else if (method == "put") {
				return await ApiService.put(url, dataObject);
			} else if (method == "delete") {
				return await ApiService.delete(url, dataObject);
			} else {
				return await ApiService.post(url, dataObject);
			}
		},

		async downloadCsv(url, filename, dataObject) {
			return await ApiService.downloadFile(url, filename, dataObject);
		},

		showSwalToast(message, type) {
			this.$swal({
				// position: 'top-end',
				icon: type,
				title: message,
        iconColor: '#0054ac',
        confirmButtonColor: "#0054ac",
				showConfirmButton: true,
				// timer: 2500,
				// toast: true
			})
		},
		showSwalError(message, type) {
		  this.$swal({
				title: message,
				icon: type,
        iconColor: '#ee66a2',
        customClass: {
          cancelButton: 'cancel-button',
        },
        confirmButtonColor: "#0054ac",
				confirmButtonText: this.$t("OK"),
      });
		},
		showSwalDelete() {
			const swalWithBootstrapButtons = this.$swal.mixin({
				customClass: {
					confirmButton: 'btn btn-success',
					cancelButton: 'btn btn-danger'
				},
				buttonsStyling: false
			})
			this.$swal({
				title: 'Are you sure?',
				text: "You won't be able to revert this!",
				icon: 'warning',
				showCancelButton: true,
				confirmButtonText: 'Yes, delete it!',
				cancelButtonText: 'No, cancel!',
				reverseButtons: true
			}).then((result) => {
				if (result.isConfirmed) {
					swalWithBootstrapButtons.fire(
						'Deleted!',
						'Your file has been deleted.',
						'success'
					)
				} else if (result.dismiss === this.$swal.DismissReason.cancel) {
					swalWithBootstrapButtons.fire(
						'Cancelled',
						'Your imaginary file is safe :)',
						'error'
					)
				}
			})
		},
		display_date_format(value) {
			if (value) {
				return moment(String(value)).format('YYYY/MM/DD')
			}
		},
		getSelectedFranchise() {},
		setSelectedFranchise() {},
		handleEnter(event) {
			if (typeof this.applyFilter == "function") {
				// multiselect 内なら無視
				if (event.target.closest('.multiselect')) {
					return;
				}
				this.applyFilter();
			}
		},
		onSelectMultiSelect() {
			// 選択したらenterボックスにフォーカスを当てエンターキーで検索できるようにする
			this.$nextTick(() => {
				const target = this.$el.querySelector('.enter');
				if (target) {
					target.focus();
				}
			});
		},
		onClosedDatePicker() {
			// 選択したらenterボックスにフォーカスを当てエンターキーで検索できるようにする
			this.$nextTick(() => {
				const target = this.$el.querySelector('.enter');
				if (target) {
					target.focus();
				}
			});
		}
	},
	computed: {
		isCreatePermitted() {
			return checkCreateButtonPermission(this.screenId)
		},
		isDeletePermitted() {
			return checkDeleteButtonPermission(this.screenId)
		},
		isUpdatePermitted() {
			return checkUpdateButtonPermission(this.screenId)
		},
		isExportPermitted() {
			return checkExportButtonPermission(this.screenId)
		},
	},
	mounted() {
		if (this.$route.meta.uID) {
			this.screenId = this.$route.meta.uID;
		}
	}
}